// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"314":"14423268","405":"14423268","642":"14423268"}[chunkId] + ".chunk.css";
};